import React, { useState, useEffect } from "react";
import { auth, RecaptchaVerifier, signInWithPhoneNumber } from "../firebase";
import { toast } from "react-toastify";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "react-toastify/dist/ReactToastify.css";

const PhoneAuth = ({ isModalOpen, setIsModalOpen }) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [isOtpSent, setIsOtpSent] = useState(false);

  useEffect(() => {
    if (isModalOpen) {
      window.recaptchaVerifier = new RecaptchaVerifier(auth, "recaptcha-container", {
        size: "normal",
      });
    }
  }, [isModalOpen]);

  const sendOtp = async () => {
    if (!phoneNumber || phoneNumber.length < 10) {
      toast.error("Please enter a valid phone number.");
      return;
    }

    try {
      const confirmation = await signInWithPhoneNumber(auth, `+${phoneNumber}`, window.recaptchaVerifier);
      setConfirmationResult(confirmation);
      setIsOtpSent(true);
      toast.success("OTP sent successfully!");
    } catch (error) {
      console.error("Error sending OTP:", error);
      toast.error("Failed to send OTP. Try again.");
    }
  };

  const verifyOtp = async () => {
    if (!otp) {
      toast.error("Please enter the OTP.");
      return;
    }

    try {
      await confirmationResult.confirm(otp);
      toast.success("Phone number verified successfully!");
      setIsModalOpen(false);
    } catch (error) {
      console.error("OTP verification failed:", error);
      toast.error("Invalid OTP. Try again.");
    }
  };

  return (
    isModalOpen && (
      <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75">
        <div className="bg-white p-6 rounded-xl shadow-lg w-96">
          <h2 className="text-xl font-bold text-gray-800 mb-4">Phone Authentication</h2>

          {!isOtpSent ? (
            <>
              <PhoneInput
                country={"in"} // Default country (India)
                value={phoneNumber}
                onChange={(value) => setPhoneNumber(value)}
                inputClass="w-full p-2 border border-gray-300 rounded-lg mb-4"
                containerClass="mb-4"
              />
              <button
                onClick={sendOtp}
                className="w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600 transition"
              >
                Send OTP
              </button>
            </>
          ) : (
            <>
              <input
                type="text"
                placeholder="Enter OTP"
                className="w-full p-2 border border-gray-300 rounded-lg mb-4"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
              <button
                onClick={verifyOtp}
                className="w-full bg-green-500 text-white py-2 rounded-lg hover:bg-green-600 transition"
              >
                Verify OTP
              </button>
            </>
          )}

          <button
            onClick={() => setIsModalOpen(false)}
            className="mt-4 w-full text-gray-500 hover:text-gray-700"
          >
            Close
          </button>

          <div id="recaptcha-container"></div>
        </div>
      </div>
    )
  );
};

export default PhoneAuth;

